module.exports = __webpack_public_path__ + "static/img/success.6a76d5d0.png";